<template lang="pug">
  nav.navbar.is-light(role='navigation' aria-label='main navigation')
    .navbar-brand
      a.navbar-item(to="/")
        img#logoBrand(src='@/assets/ducter_color.png')
      a#navBurger.navbar-burger.burger(role='button' aria-label='menu' aria-expanded='false' data-target='navbarMenu' @click="displayBurger")
        span(aria-hidden='true')
        span(aria-hidden='true')
        span(aria-hidden='true')
    #navbarMenu.navbar-menu
      .navbar-start
        .navbar-item(@click="irToHome")
          .buttons
            a.button.is-light
              i.fas.fa-home
              | &nbsp Home
      .navbar-end
        .navbar-item
          .buttons
            a.button.is-primary {{ userLogin.nombre }}
            a.button.is-primary(@click="salirSistema")
              | Salir &nbsp
              i.fas.fa-door-open
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'NavBarAccesos',
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      }
    },
    displayBurger () {
      let burger = document.getElementById('navBurger')
      let nav = document.getElementById(burger.dataset.target)
      burger.classList.toggle('is-active')
      nav.classList.toggle('is-active')
    },
    salirSistema () {
      this.userSeguridad = {}
      sessionStorage.clear()
      this.$store.commit('setlogin', false)
      this.$store.commit('usuarioLogueado', {})
      this.$router.push('/')
    },
    irToHome () {
      
      switch (this.userLogin.ubicacion) {
        case 'IRGE':
          this.$router.push('/IRGE')
          break;
        case 'TPA':
          this.$router.push('/TPA')
          break;
        case 'EB00':
          this.$router.push('/Estacion')
          break;
        case 'EB01':
          this.$router.push('/Estacion')
          break;
        case 'EB02':
          this.$router.push('/Estacion')
          break;
        case 'EB03':
          this.$router.push('/Estacion')
          break;
        case 'EB04':
          this.$router.push('/Estacion')
          break;
        case 'CORP':
          this.$router.push('/Corporativo')
          break;
        case 'ALL':
          this.$router.push('/Admin')
          break;
        case 'EXT':
          this.$router.push('/Externo')
          break
        default:
          this.$router.push('/')
          break;
      }
    }
  },
  created() {
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  }
}
</script>

<style lang="css">
  #logoBrand {
    max-width: 150px;
  }

  .navbar-item img {
    max-height: 100%;
  }

  .navbar.is-light {
    height: 80px;
  }

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/accesos/layout/NavBar.vue